export const LOTTIE_JSON_ON_INITIALIZE = "LOTTIE_JSON_ON_INITIALIZE";

export const LOTTIE_JSON_ON_INITIALIZE_SUCCEDED =
  "LOTTIE_JSON_ON_INITIALIZE_SUCCEDED";

export const LOTTIE_JSON_ON_INITIALIZE_FAILED =
  "LOTTIE_JSON_ON_INITIALIZE_FAILED";
